import { expenditureResolutionApi } from "../api/generated/wrappers/expenditure-resolution";
import { createQueryKeys } from "./create-query-keys";
const expenditureResolutionQueryKeys = createQueryKeys("expenditureResolution", {
    list: (params) => ({
        queryKey: ["list", params],
        queryFn: async () => await expenditureResolutionApi.getExpenditureResolutions(params),
    }),
    detail: (id) => ({
        queryKey: ["detail", id],
        queryFn: async () => await expenditureResolutionApi.getExpenditureResolution(id),
    }),
});
export default expenditureResolutionQueryKeys;
